module.exports = "<!--\r\nAuto-generated\r\nDo not edit!!!\r\n-->\r\n<div class=\"kb-data-form\">\r\n    <div class=\"kb-data-form-fieldset\">\r\n        <div class=\"kb-components-container\">\r\n            <ng-content></ng-content>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/shared/components/data-form/data-form.component.html
// module id = ../../../../../src/app/shared/components/data-form/data-form.component.html
// module chunks = main